module.exports = __webpack_public_path__ + "img/markmasons.dc29936a.png";